import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../core/services/data.service';
import { NotificationService } from '../../core/services/notification.service';
import { environment } from '../../../environments/environment';
import { CustomerObjectNeedServiceCallListItem } from '../../shared/models/customer-object-service-calls/customer-object-need-service-call-list-item';
import { ActionDataResult } from '../../shared/models/core/ActionDataResult';
import { ListViewModel } from '../../shared/models/core/ListViewModel';
import { Observable } from 'rxjs';
import { filter, take, tap } from 'rxjs/operators';
import { DataSourceRequestState, toDataSourceRequestString } from '@progress/kendo-data-query';
import { NotificationType } from '../../core/services/notification-type';
import { CustomerObjectServiceCallDto } from '../../shared/models/customer-object-service-calls/customer-object-service-call.dto';

@Injectable({
	providedIn: 'root'
})
export class CustomerObjectServiceCallsService extends DataService<CustomerObjectNeedServiceCallListItem, CustomerObjectServiceCallDto> {

	constructor(http: HttpClient, notificationService: NotificationService) {
		super(http, notificationService);
		this.controllerName = 'customer-object-service-calls';
	}

	createComment(
		customerObjectId: number,
		serviceCallComment: string,
		serviceCallFinalised: boolean = false,
		postponeServiceCallDateTime: Date = null,
		postponeForever: boolean = false
	): Observable<ActionDataResult<number>> {
		return this.http.post<ActionDataResult<number>>(this.baseUrl(), {
			customerObjectId,
			serviceCallComment,
			serviceCallFinalised,
			postponeServiceCallDateTime,
			postponeForever
		});
	}

	performServiceCall(customerObjectId: number, needPerform: boolean): Observable<any> {
		return this.postQuery(`${this.baseUrl()}/perform-service-call`, { customerObjectId: customerObjectId, needPerform })
	}
}

